import { render, staticRenderFns } from "./ChannelBroadcasts.vue?vue&type=template&id=3a207662&scoped=true&"
import script from "./ChannelBroadcasts.vue?vue&type=script&lang=js&"
export * from "./ChannelBroadcasts.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBroadcasts.vue?vue&type=style&index=0&id=3a207662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a207662",
  null
  
)

export default component.exports